import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { AllocationPeriodType } from '~/types';
import { useBulkProposeAllocationsForResourceRequest } from '~/modules/resourcing/common/hooks';
import useResourceAllocationToolbarStateContext from '~/modules/resourcing/hooks/useResourceAllocationToolbarStateContext';
import ShowSmartFitDialogOrLoading2 from '~/modules/resourcing/components/ResourceAssignmentDialog/components/ResourceUsersChartPanel/components/ShowSmartFitDialogOrLoading/ShowSmartFitDialogOrLoading2';

const ProposeWithSmartFitDialog = ({ smartFitState, onClose }) => {
  const { resourceRequest, resourceUser } = smartFitState;

  const {
    bulkProposeAllocationsForResourceRequest
  } = useBulkProposeAllocationsForResourceRequest();

  const { scale } = useResourceAllocationToolbarStateContext() || {};

  const allocationDateRange = useMemo(
    () => ({
      startDate: resourceRequest.startDate,
      endDate: resourceRequest.endDate
    }),
    [resourceRequest]
  );

  const totalAllocatedHours = resourceRequest.totalHours;

  const proposeAllocation = useCallback(
    (_overrideScheduleRules, distributionMode) => {
      bulkProposeAllocationsForResourceRequest({
        submittedResourceRequestsWithMatches: [
          {
            resourceRequest,
            userIds: [resourceUser.id],
            ...(distributionMode && {
              allocationHoursInDateRangeInput: {
                dateRange: allocationDateRange,
                hoursPerPeriod: totalAllocatedHours,
                periodType: AllocationPeriodType.EntireRange,
                distributionMode
              }
            })
          }
        ]
      });
      onClose();
    },
    [
      bulkProposeAllocationsForResourceRequest,
      resourceRequest,
      resourceUser.id,
      allocationDateRange,
      totalAllocatedHours,
      onClose
    ]
  );

  return (
    <ShowSmartFitDialogOrLoading2
      resourceUser={resourceUser}
      totalAllocatedHours={totalAllocatedHours}
      allocationDateRange={allocationDateRange}
      createAllocationWithUserAndOverrideRules={proposeAllocation}
      closeShowSmartFitDialogOrLoading={onClose}
      scale={scale}
    />
  );
};

ProposeWithSmartFitDialog.propTypes = {
  smartFitState: PropTypes.shape({
    resourceRequest: PropTypes.object.isRequired,
    resourceUser: PropTypes.object.isRequired
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

export default ProposeWithSmartFitDialog;
